import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify'; // Import for toast notifications
import DynamicNFTCard from '../DynamicCard'; // Component to display individual NFT cards
import CardPlaceholder from '../../cards/NFTCardPlaceholder'; // Skeleton loader for NFTs
import { listNFTs } from '../../../hooks/NFTHook'; // API hook for fetching NFT data

function MostPopular(props) {
  // State variables
  const [nfts, setNfts] = useState([]); // Stores the fetched NFTs
  const [hasMore, setHasMore] = useState(true); // Determines if there are more NFTs to load
  const [loading, setLoading] = useState(true); // Indicates if data is being loaded

  // Retrieve user-specific data from localStorage
  const userWalletAddress = localStorage.getItem('WalletAddress');
  const userIds = localStorage.getItem('userId');

  // Check if the component is being used for the current user or general view
  const isUser = props?.user ?? false;

  // Fetch most-viewed NFTs when the component mounts
  useEffect(() => {
    fetchMostViewedNFTs();
  }, [props.filter]);

  /**
   * Fetch the most-viewed NFTs
   * - If `isUser` is true, fetch NFTs owned by the user sorted by views.
   * - Otherwise, fetch globally most-viewed NFTs.
   */
  const fetchMostViewedNFTs = async () => {
    try {
      setLoading(true); // Start loading

      // Define API parameters based on whether the view is user-specific
      let Params;
      if (props.filter === "all") {
        Params = isUser
          ? { page: 1, limit: 4, sortBy: "totalViews", ownerAddress: userWalletAddress }
          : { page: 1, limit: 4, sortBy: "totalViews" };
      }
      else {
        Params = isUser
          ? { page: 1, limit: 4, sortBy: "totalViews", category: props.category, ownerAddress: userWalletAddress }
          : { page: 1, limit: 4, sortBy: "totalViews", category: props.category, };
      }
      
      // Call the API to fetch NFT data
      const allNFTResponse = await listNFTs(Params);
      console.log("allNFTResponse", allNFTResponse);

      if (allNFTResponse.success) {
        const allNFTs = allNFTResponse.data;

        // Add `isLike` flag to each NFT based on whether the user has liked it
        const AddIsLikeFlag = allNFTs.map(item => {
          const isLike = item.likes.some(like => like.userId === userIds); // Check if the user has liked the NFT
          return { ...item, isLike };
        });

        setNfts(AddIsLikeFlag); // Update state with processed NFT data

        // If no NFTs are available, disable loading more
        if (allNFTs.length === 0) {
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Error fetching NFTs:", error);
      toast.error("Failed to fetch NFTs. Please try again."); // Display error notification
    } finally {
      setLoading(false); // End loading
    }
  };

  return (
    <div>
      <div className="row">
        {/* Show skeleton placeholders while loading */}
        {loading ? (
          [...Array(4)].map((_, index) => (
            <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
              <CardPlaceholder /> {/* Placeholder for loading state */}
            </div>
          ))
        ) : nfts.length > 0 ? (
          // Render the most popular NFTs
          nfts.map((val, index) => (
            <div key={index} className="col-lg-3 col-md-4 col-sm-6 card-hover-effect">
              <DynamicNFTCard
                NFTLink={`/nftdetails/${val.contractAddress}/${val._id}`} // Dynamic NFT details link
                contractAddress={val.contractAddress}
                currentOwnerPic={val?.currentOwner?.userId?.profilePicture} // Owner's profile picture
                currentOwnerName={val?.currentOwner?.userId?.name} // Owner's name
                currentOwnerLink={val?.currentOwner?.walletAddress !== userWalletAddress ? `/otherProfile/${val?.currentOwner?.walletAddress}` : "/profile"} // Owner's profile link
                mediaUrl={val.imageUri} // Media URL (image or video)
                assetType={val.assetType} // Asset type (video or image)
                title={val.title} // NFT title
                price={val.price} // NFT price
                likes={val.totalLikes} // Total likes count
                isLiked={val.isLike} // Whether the NFT is liked by the user
                tokenId={val.tokenId} // Token ID of the NFT
                isListed={val.listed} // Whether the NFT is listed for sale
                nftId={val._id} // Unique NFT ID
              />
            </div>
          ))
        ) : (
          // Message displayed if no NFTs are available
          <h3>No NFTs Available</h3>
        )}
      </div>

  </div>
  );
}

export default MostPopular;
